<template>
  <div>
    <div class="modal-backdrop fade show"></div>

    <div
        class="modal fade show modal-dialog-centered modal-dialog-scrollable"
        style="padding-right: 12px; display: block;">
      <div class="modal-dialog modal-xl modal-dialog-scrollable">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              {{ isAdd ? 'Новое заключение' : 'Редактирование' }}.
            </h5>

            <button type="button" class="close" @click="$emit('cancel')">
              <span aria-hidden="true">×</span>
            </button>
          </div>

          <div class="modal-body">
            <form>
              <div class="form-group">
                <label>Дата</label>
                <input type="text" class="form-control" v-model="dateFrom"/>
                <small class="form-text text-muted">формат: YYYY-MM-DD</small>
              </div>

              <div class="form-group">
                <label>Диагностическое представление</label>
                <textarea class="form-control" v-model="text" rows="10"></textarea>
              </div>

              <div class="form-group">
                <label>Дополнительные обследования</label>
                <textarea class="form-control" v-model="note"></textarea>
              </div>

              <div class="form-group">
                <label>Консультации узкопрофильных специалистов</label>
                <textarea class="form-control" v-model="additional"></textarea>
              </div>
            </form>

            <div v-if="error" class="alert alert-danger">{{error}}</div>
          </div>

          <div class="modal-footer justify-content-between">
            <div>
              <button v-if="!isAdd" type="button" class="btn btn-danger" @click="deleteItem">
                Удалить
              </button>
            </div>

            <div>
              <button type="button" class="btn btn-primary" @click="submitForm">
                {{ isAdd ? 'Добавить' : 'Обновить' }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import formatDate from '../../../../utils/formatDate';

export default {
  name: 'ClientConclusionConclusionForm',

  props: ['conclusion'],

  data() {
    return {
      error: '',
      text: '',
      note: '',
      additional: '',
      dateFrom: formatDate(new Date(), 'y-m-d'),
    };
  },

  created() {
    if (typeof this.conclusion !== 'undefined') {
      this.text = this.conclusion.text;
      this.note = this.conclusion.note;
      this.additional = this.conclusion.additional;
      this.dateFrom = formatDate(new Date(this.conclusion.dateFrom), 'y-m-d');
    }
  },

  computed: {
    isAdd() {
      return typeof this.conclusion === 'undefined';
    },
  },

  methods: {
    submitForm() {
      this.error = '';

      if (typeof this.text !== 'string' || this.text.trim() === '') {
        this.error = 'Нужно заполнить текст заключения';
      }

      if (typeof this.dateFrom !== 'string' || this.dateFrom.trim() === '') {
        this.error = 'Дата не указана';
      }

      if (/^[0-9]{4}-[0-9]{2}-[0-9]{2}$/.test(this.dateFrom) !== true) {
        this.error = `Дата указана неправильно`;
      }

      if (this.error !== '') {
        return;
      }

      const data = {
        text: this.text,
        note: this.note,
        additional: this.additional,
        dateFrom: this.dateFrom
      };

      if (typeof this.conclusion !== 'undefined') {
        data.id = this.conclusion.id;
      }

      this.$emit('submit', data);
    },

    deleteItem() {
      if (!this.isAdd && typeof this.conclusion.id === 'string') {
        this.$emit('delete', this.conclusion.id);
      }
    },
  },
};
</script>
